<script setup>
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

defineProps({
  text: {
    type: String,
    default: '',
  },
  margin: {
    type: String,
    default: 'mb-14',
  },
  signupExpired: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <BasicBlock :icon="['fal', 'alarm-clock']">
    <span v-if="!signupExpired" :aria-label="text">{{ text }}</span>
    <span v-else class="text-error" :aria-label="$t('global.signUpExpired')">{{
      $t('global.signUpExpired')
    }}</span>
  </BasicBlock>
</template>
